var _path;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
const SvgLogoMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 24,
  fill: "none",
  viewBox: "0 0 40 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 13.677q10.158 0 20 1.258v-5.87a158 158 0 0 1-20 1.258c-6.772 0-13.49-.42-20-1.258v5.817a167 167 0 0 1 20-1.205M40 0c-5.88 3.354-12.703 5.345-20 5.345S5.88 3.354 0 0v6.183A81.4 81.4 0 0 0 20 8.7c6.877 0 13.596-.891 20-2.516zM40 24v-6.183A81.4 81.4 0 0 0 20 15.3c-6.877 0-13.596.891-20 2.516V24c5.88-3.406 12.703-5.345 20-5.345S34.12 20.594 40 24"
})));
export default SvgLogoMark;